import { useLocation } from "@reach/router";
import { navigate } from "gatsby";
import React, { MouseEvent } from "react";
import registrationOnlyMode from "../../hooks/registrationOnlyMode";
import useAuthModal from "../../hooks/useAuthModal";
import useEventDetails from "../../hooks/useEventDetails";
import { AuthLink } from "../links";

interface ButtonDefaultProps {
  className?: string;
  signInRedirect?: string;
  signOutRedirect?: string;
  autoText?: boolean;
}

export default ({
  className,
  signInRedirect = "/virtual/live",
  signOutRedirect = "/",
  closeMenu,
  autoText,
}: ButtonDefaultProps) => {
  const { registrationOnly, virtual } = useEventDetails();
  const { opened, openModal, user, signOut } = useAuthModal();

  const handleLogout = async (event: MouseEvent) => {
    event.preventDefault();
    if (registrationOnly && !opened) {
      openModal();
    }
    await signOut();
    navigate(signOutRedirect, {
      replace: true,
    });
    closeMenu();
  };

  return (
    <>
      {user ? (
        <a href="#" className={className} onClick={handleLogout}>
          {registrationOnly ? "Register" : "Logout"}
        </a>
      ) : (
        <AuthLink
          to={signInRedirect}
          className={className}
          autoText={autoText}
          closeMenu={closeMenu}
        >
          {registrationOnly ? "Register" : "Login"}
        </AuthLink>
      )}
    </>
  );
};
